import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'trial-used',
  templateUrl: './trial-used.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FormsModule, AsyncPipe],
})
export class TrialUsedComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output<{ action: string; columnData: any }>();
  constructor() {}

  ngOnInit(): void {}

  OpenTrialHistory(data: any) {
    this.onAction.emit({ action: 'OpenTrialHistory', columnData: data });
  }
}
